exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scheduledCampaign[data-v-77f4b296] {\n    background: #fb8c0020;\n}\n\n", ""]);

// exports
